import { StreamActions, StreamElement } from '@hotwired/turbo'
import { Turbo } from '@hotwired/turbo-rails'

interface TemplateableStreamElement extends StreamElement {
  templateElement?: HTMLTemplateElement
}

StreamActions.delay_actions = function (this: TemplateableStreamElement) {
  const duration = parseInt(this.getAttribute('duration') || '0', 10)
  const delayedActions = this.templateElement?.innerHTML

  if (!delayedActions) {
    return console.warn(
      'The `delay_actions` Turbo Stream action requires a child `<template>` element with nested `<turbo-stream action="*" />` elements.',
    )
  }

  window.setTimeout(() => Turbo.renderStreamMessage(delayedActions), duration)
}
